export default "__VITE_ASSET__e17267a9__"